import { useCallback, useEffect, useState } from 'react';

import { DuplicateModal } from '~extension/web2print/view/DuplicateForm/DuplicateModal';
import useDelayFn from '~hooks/useDelayFn';
import { AssetId } from '~modules/media-library/model/Asset';

export function DuplicateModalController({ assetId, onClose }: { assetId: AssetId; onClose: () => void }) {
  const delayedOnClose = useDelayFn(onClose, 500);
  const [isOpen, setIsOpen] = useState(false);

  // open modal when settings are loaded
  useEffect(() => {
    setIsOpen(Boolean(assetId));
  }, [assetId]);

  // Handler: close dialog, but delay the closing to have smoother transitions
  const handleOnClose = useCallback(() => {
    setIsOpen(false);
    delayedOnClose();
  }, [delayedOnClose]);

  return <DuplicateModal isOpen={isOpen} onClose={handleOnClose} assetId={assetId} />;
}
